import contributors from './contributors';

export default Project;

function fetchIcp(slug) {
    if (!slug) return null;

    var query = {
        offset: 0,
        limit: 1
    };

    if (slug) query.project__slug = slug;

    return Vue.http
        .get('icp/?' + queryString.stringify(query))
        .then(function(res) {
            return res.body.results[0];
        });
}

function Project(opts) {
    var __promise = null;
    var __contributorsPromise = null;

    opts = opts || {};
    Object.assign(this, opts);

    Object.defineProperty(this, 'promise', {
        get: () => {
            if (!__promise) __promise = Vue.http
                .get('projects/' + this.slug + '/')
                .then((res) => res.body);

            return __promise;
        }
    });

    Object.defineProperty(this, 'contributorsPromise', {
        get: function() {
            if (!__contributorsPromise) __contributorsPromise = contributors.fetch(this);
            return __contributorsPromise;
        }
    });
}
